import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  const forYou = ['Tenés una air fryer y casi no la usás', 'No sabés cocinar o sabés muy poco', 'Querés comer mejor sin complicarte', 'Siempre terminás pidiendo delivery', 'Querés recetas con ingredientes de heladera común'];
  const notForYou = ['Ya cocinás seguido y bien', 'Buscás recetas gourmet o complicadas', 'No tenés air fryer (aunque... deberías conseguirte una)'];
  return <section className="py-20 px-4 bg-brand-purpleLight" data-id="element-67">
      <div className="max-w-5xl mx-auto" data-id="element-68">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray text-center mb-12" data-id="element-69">
          ¿Es para vos?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-70">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-green-500" data-id="element-71">
            <div className="flex items-center gap-2 mb-6" data-id="element-72">
              <div className="bg-green-500 text-white w-8 h-8 rounded-full flex items-center justify-center" data-id="element-73">
                <Check className="w-5 h-5" strokeWidth={3} data-id="element-74" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-brand-darkGray" data-id="element-75">
                ES PARA VOS SI:
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-76">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-77">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-78" />
                  <span className="text-brand-darkGray font-medium" data-id="element-79">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-red-500" data-id="element-80">
            <div className="flex items-center gap-2 mb-6" data-id="element-81">
              <div className="bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center" data-id="element-82">
                <X className="w-5 h-5" strokeWidth={3} data-id="element-83" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-brand-darkGray" data-id="element-84">
                NO ES PARA VOS SI:
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-85">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-86">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-87" />
                  <span className="text-brand-darkGray font-medium" data-id="element-88">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}